import { FarmConfig } from '~/config/constants/types'
import { SerializedFarm } from '~/state/types'
import fetchPublicFarmData from './fetchPublicFarmData'
import { toSerializeFarmConfig } from './helpers'

const fetchFarm = async (chainId, farm: FarmConfig): Promise<SerializedFarm> => {
  const farmPublicData = undefined //await fetchPublicFarmData(chainId, farm)

  const serializedFarmConfig = toSerializeFarmConfig(chainId, farm)

  return { ...serializedFarmConfig, ...farmPublicData }
}

export default fetchFarm
